import { api } from "../../state/api";
import type { AppResponse } from "../../state/api.types";
import { SandboxActions } from "./SandboxActions";
import { SandboxPreview } from "./SandboxPreview";
import { SandboxStatus } from "./SandboxStatus";

type SandboxCardProps = {
  app: AppResponse;
};

export const SandboxCard = (props: SandboxCardProps) => {
  const getDebugAccount = api.useGetDebugAccountQuery({
    appUUID: props.app.uuid,
  });

  if (!getDebugAccount.data) {
    return null;
  }

  return (
    <div className="rounded-xl border border-secondary p-3xl">
      <div className="text-lg font-semibold">Sandbox tool</div>
      <div className="text-sm text-tertiary">
        Use your own email ({getDebugAccount.data.email}) to preview and debug
        what your customer experiences as their account status changes.
      </div>
      {props.app.is_sandbox ? (
        <div className="mt-3xl space-y-3xl">
          <div>
            <div className="mb-sm text-sm font-medium text-secondary">
              Account status
            </div>
            <SandboxStatus
              location={getDebugAccount.data.locations[0]}
              enrollment={getDebugAccount.data.enrollment}
            />
          </div>
          <div>
            <div className="mb-sm text-sm font-medium text-secondary">
              Available actions
            </div>
            <SandboxActions
              app={props.app}
              location={getDebugAccount.data.locations[0]}
              enrollment={getDebugAccount.data.enrollment}
            />
          </div>
          <div>
            <div className="mb-sm text-sm font-medium text-secondary">
              Preview customer experience
            </div>
            <SandboxPreview
              app={props.app}
              enrollment={getDebugAccount.data.enrollment}
              onClose={() => {
                getDebugAccount.refetch();
              }}
            />
          </div>
        </div>
      ) : (
        <div className="p-4xl text-center text-sm text-tertiary">
          The sandbox tool is only available in sandbox apps to simulate fake
          data. Switch to a sandbox app to start testing your experience.
        </div>
      )}
    </div>
  );
};
